export {PagesSlider} from './PagesSlider';
